import classes from './Loading.module.scss';

export function Loading() {


    return (
        <div id="eduLdg" className={classes.edu__ldg}>
            <span className={classes.edu__ldg__smb}>
                <svg className={classes.edu__ldg__smb__svg} width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect className={classes.edu__ldg__smb__svg__wp} width="100" height="100" fill="none" />
                    <path className={classes.edu__ldg__smb__svg__bx} d="M77.56 16.1121L29.46 12.0121C17.36 11.6121 8.16001 21.2121 9.06001 33.3121L9.76001 39.3121L14.16 73.0121C14.76 81.3121 22.06 87.9121 30.36 87.5121L69.86 84.4121C78.26 84.0121 85.56 77.0121 86.26 68.6121L91.36 31.7121C92.16 23.4121 85.86 16.4121 77.56 16.1121Z" fill="#80BC00" />
                    <path className={classes.edu__ldg__smb__svg__e} d="M61.5404 62.9123C59.5655 64.5958 55.8127 67.0021 50.6803 67.0021C42.7129 67.0021 34 61.2729 34 50.6431C34 39.6166 42.7129 34.0021 50.6803 34.0021C60.2533 34.0021 65.4705 41.9083 66.5361 46.1832C67.9344 51.7928 66.0776 51.3306 62.2283 51.3306C59.1488 51.3306 42.9817 51.3306 35.2831 51.3306" stroke="white" strokeWidth="7.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </span>
            <div className={classes.edu__ldg__tx}>
                <div id="edu_ldg_prc" className={classes.edu__ldg__tx__nf}></div>
            </div>
        </div>
    );
}

